class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"], #mobile_search');
    this.predictiveSearchResults = this.querySelector('#predictive-search, #predictive-search-1');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        this.trackPredictiveResults(searchTerm);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  trackPredictiveResults(searchTerm) {
    if (typeof posthog === 'undefined') return;
    const items = this.predictiveSearchResults.querySelectorAll('li[role="option"]');
    const resultsCount = items.length;
    const device = /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';

    // Fire for zero-results queries so the "no results" signal is real
    if (resultsCount === 0) {
      posthog.capture('Search Performed', {
        query: searchTerm,
        results_count: 0,
        has_results: false,
        source: 'predictive',
        device: device
      });
      return;
    }

    // Fire on result selection (click)
    items.forEach((item, index) => {
      const link = item.querySelector('a');
      if (!link) return;
      link.addEventListener('click', () => {
        posthog.capture('Search Performed', {
          query: searchTerm,
          results_count: resultsCount,
          has_results: true,
          source: 'predictive',
          result_position: index + 1,
          device: device
        });
      });
    });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);